// Section 17 and 18: Food floor policy. 0.25 / 0.5 / 0.75 of need; applies to the floor policy.
// Default: config.policies.defaults.foodFloor.
import type { Config } from '../../config';
import { noChangeCost, noProblem } from '../../core/content-helpers';
import { peopleSorted } from '../../core/queries';
import { definePolicy, noModifiers } from '../../core/registry';
import type { FoodFloor } from '../../core/types';

export function foodFloor(config: Config) {
  return definePolicy({
    id: 'foodFloor',
    label: 'Food floor',
    section: 'S18',
    group: 'rations',
    options: config.rationing.floors as FoodFloor[],
    default: config.policies.defaults.foodFloor,
    modifierTargets: [],
    modifiers: noModifiers,
    changeCost: noChangeCost,
    affects(ctx, floor) {
      const applies = ctx.state.policies.foodRation === 'floor-priority';
      return [
        {
          key: applies ? 'policy.foodFloor.applies' : 'policy.foodFloor.unused',
          params: { floor: Math.round(floor * 100), people: peopleSorted(ctx.state).length },
        },
      ];
    },
    validate: noProblem,
  });
}
